import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { isNewTextFieldEnabled } from '@helpcenter/feature-flags';
import * as grid from '@helpcenter/styles/src/grid';
import { ThemedButton } from '@helpcenter/themed-button';
import { useIntl } from 'react-intl-next';
import { TextField } from 'view/common/fields/text-field';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import { ButtonContainer } from '../login-single-sign-on/styled';
import messages from './messages';

export interface LoginSingleSignOnCustomerProps {
    email: string;
    redirectLink?: string;
    passwordLoginAvailable: boolean;
    onContinueWithPassword: () => void;
}

const LoginSingleSignOnCustomer = (props: LoginSingleSignOnCustomerProps) => {
    const { email, redirectLink, passwordLoginAvailable, onContinueWithPassword } = props;
    const { formatMessage } = useIntl();

    const getContinueWithPasswordLink = () => {
        return passwordLoginAvailable ? (
            <FooterContainer>
                <ThemedButton appearance="link" actionSubjectId="continueWithPassword" onClick={onContinueWithPassword}>
                    {formatMessage(messages.continueWithPasswordButton)}
                </ThemedButton>
            </FooterContainer>
        ) : undefined;
    };

    return (
        <Container>
            <FireScreenEventOnMount />
            <TextField
                id="user-email"
                shouldFitContainer
                label={formatMessage(messages.emailLabel)}
                disabled
                defaultValue={email}
                updatedTextField={isNewTextFieldEnabled()}
            />
            <ButtonContainer>
                <ThemedButton
                    id="continue-with-customer-sso-button"
                    appearance="primary"
                    shouldFitContainer
                    actionSubjectId="continueWithCustomerSSO"
                    isDisabled={redirectLink === undefined}
                    href={redirectLink}
                    // Disabling existing violations, should be fixed when revisited.
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus
                >
                    {formatMessage(messages.continueWithSingleSignOnButton)}
                </ThemedButton>
            </ButtonContainer>
            {getContinueWithPasswordLink()}
        </Container>
    );
};

export default LoginSingleSignOnCustomer;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const FooterContainer = styled.div`
    margin-top: ${grid.multiple(4.25).px};
    text-align: center;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Container = styled.div`
    text-align: left;
`;
